import { render, staticRenderFns } from "./m-reviews.vue?vue&type=template&id=e5d92192&scoped=true"
import script from "./m-reviews.vue?vue&type=script&lang=js"
export * from "./m-reviews.vue?vue&type=script&lang=js"
import style0 from "./m-reviews.vue?vue&type=style&index=0&id=e5d92192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d92192",
  null
  
)

export default component.exports